<template>
    <el-drawer
        title="用户票夹列表"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <div class="ticketMain">
            	<template v-if="dataList && dataList.length > 0">
            		<div  v-for="(item,index) in dataList" :key="index"  :class="['item-list',
            			item.operateStatus == 6 || item.operateStatus == 3 || item.operateStatus == 4 || item.operateStatus == 1 ? 'white' : '',
            			item.operateStatus == 7 ? 'gray' : '',
            			item.operateStatus == 5 ? 'status5': ''
            		]">			
            			<div
            				:class="['giftIcon' , 
            				item.presentStatus == 2 ? 'sendOther' : '',
            				item.presentStatus == 3 ? 'fromFriend' : '',
            				item.presentStatus == 4 ? 'showstartSend' : ''
            			]"></div>
            			<!-- 2：演出结束 3：用户取消 4：演出取消 -->
            			<div
            				v-show="item.status == 2 || item.status == 3 || item.status == 4"
            				:class="['statusIcon' , 
            				item.status == 2 ? 'activityCancel' : '',
            				item.status == 3 ? 'userCancel' : '',
            				item.status == 4 ? 'end' : ''
            			]"></div>
            			
            			<div class="top" >
            				<div class="img">            					
								<img :src="item.poster">
            				</div>
            				<div class="rightText">
            					<div class="name">{{item.activityName}} </div>
            					<div class="address">{{item.cityName}} {{item.siteName}}</div>
            					<div class="time">{{item.sessionStartTime}}</div>
            				</div>
            			</div>					
            			<div class="center">
            				<div class="mid" v-if="item.operateStatus == 1 && !item.tips3">							
            					<div class="midText"  hover-class="none" >
            						<span v-if="item.sessionShowCodeStatus == 1">入场请出示二维码</span>
            						<span v-else>须携带观演人身份证件入场</span>
            					</div>
            				</div>
            				<!-- <div class="mid" v-if="( item.operateStatus == 2 || item.operateStatus == 3 ) && item.presentStatus != 2">
            					<div class="midText">
            						<el-image src="@/assets/img/ticket/icon_wraning.png" class="wraningIcon"></el-image>
            						<span class="midWenzi">该票品需实名绑定后才能使用</span>
            					</div>
            					<div class="midBtn">绑定观演人</div>
            				</div> -->
            				<!-- <div class="mid" v-if="item.operateStatus == 3 && item.presentStatus == 3">
            					<div class="midText">
            						<image src="../../static/icon_wraning.png" class="wraningIcon"></image>
            						<span>该票品需实名绑定后才能使用</span>
            					</div>
            					<div class="midBtn" @click="AddViewer(item.id)">绑定观演人</div>
            				</div> -->
            				<div class="mid" v-if="item.tips3">
            					<div class="midText">
            						<span>{{item.tips3}}</span>
            					</div>				
            				</div>
            				<template v-else>
            					<div class="mid" v-if="item.operateStatus == 3 && item.presentStatus == 2 && item.tips2">
            						<div class="midText">						
            							<span>{{item.tips2}}</span>
            						</div>					
            					</div>
            					<div class="mid" v-if="item.operateStatus == 4 && item.presentStatus == 4">
            						<div class="midText"  hover-class="none"  >
            							<span v-if="item.sessionShowCodeStatus == 1">入场请出示二维码</span>
            							<span v-else>须携带观演人身份证件入场</span>
            						</div>				
            					</div>
            					<div class="mid" v-if="item.operateStatus == 4 && item.presentStatus == 2 && item.tips2">
            						<div class="midText">
            							<span>{{item.tips2}}</span>
            						</div>				
            					</div>
            					<div class="mid" v-if="item.operateStatus == 4 && (item.presentStatus == 3 || item.presentStatus == 1 )">
            						<div class="midText"  hover-class="none"  >						
            							<span v-if="item.sessionShowCodeStatus == 1">入场请出示二维码</span>
            							<span v-else>须携带观演人身份证件入场</span>
            						</div>					
            					</div>
            					<div class="mid" v-if="item.operateStatus == 5">
            						<div class="midText"  hover-class="none">						
            							<span v-if="item.sessionShowCodeStatus == 1">入场出示二维码并携带有效证件</span>
            							<span v-else>须携带观演人身份证件入场</span>
            						</div>
            						<!-- <div class="midCheckuser">{{item.tips2}}</div> -->
            					</div>
            					<div class="mid" v-if="item.operateStatus == 6">
            						<div class="midText">
            							<span>请提前到场凭取票码入场</span>
            						</div>					
            					</div>
            				</template>
            				<div v-if="item.lineType" class="ticketNumView">
            					<!-- <div v-if="item.showTicketNumView">主办方已开启<span class="theme-color">{{item.lineType == 2 ? '入场序号' : '座位号'}} </span> {{item.showTicketNumView}}</div>
            					<div v-if="!item.showTicketNumView && item.ticketNum">{{item.lineType == 2 ? '入场序号' : '座位号' }}：<span class="theme-color">{{item.ticketNum}}</span></div> -->
            					<div v-if="item.ticketNum">{{item.ticketNum}}</div>
            					<div v-if="item.ticketNumType && item.ticketNumType == 1 ">演出需要通过入场号入场，请进入详情页领取</div>
            				</div>
            				<div class="midCheckuser" v-if="item.operateStatus == 5 && item.tips2">
            					{{item.tips2}}
            				</div>
            			</div>
            			<div :class="['bot' , 
            				item.operateStatus == 6 ? 'red' : '',
							item.operateStatus == 1 ? 'red' : '',
							item.operateStatus == 7 ? 'red' : '',
							item.operateStatus == 5 ? 'blackbg' : '',
							item.operateStatus == 4 ? 'red' : '',
							item.operateStatus == 9 ? 'red' : '',
							item.presentStatus == 2 ? 'normal' : ''
							]">
            				<span class="tkid" v-if="item.ticketId">TKID: {{item.ticketId}}</span>
            				<div class="tkStyle">
            					<div class="tkName"><img src="@/assets/img/ticket/ticketicon.png"  class="icon"/>{{item.ticketName}}</div>
            					<!-- <div class="tkSend" v-if="(item.operateStatus == 2 || item.operateStatus == 1 ) && item.presentStatus == 1 && item.isWriteOff == 0 "  >
								<img src="@/assets/img/ticket/gifticon.png" class="icon">赠予好友</div> -->
            				</div>
            			</div>
            		</div>
            	</template>
            	<template v-else>
            		<div class="ticketNodata">
            			<!-- <image :src="ticketopen" mode="widthFix"></image> -->
            			<span>用户票夹暂无数据</span>
            		</div>
            	</template>
            	
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>          
        </div>
    </el-drawer>
</template>

<script>


export default {
    data(){
        return{
            drawerShow: false,                      
            id:'',
			dataList:[],
        }
    },
    created(){
        
    },
    methods:{
        close(){            
            this.drawerShow = false;
			this.dataList = []
        },
        show(id){
            this.id = id;          
            this.drawerShow = true;
			this.getData();
        },
        getData(){
			this.$request({
				url: "/callCenter/walletList",
				method: "POST",
				params: {
					userId:this.id,
					pageNo:1,
					pageSize:100
				},
			})
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 ) {
					this.dataList = result					
				} else {
					this.$message.error(msg || "请求失败");
				}
			})	
        },
        
    }
}
</script>
<style lang="scss" scoped>
.ticketMain{
	.icon{
		width: 12px;
		height:12px;
		vertical-align: middle;
		display: inline-block;
		margin-right: 3px;
	}
	padding:10px;
	background: #ebebeb;
	background-size: 100%;		
	.item-list{
		position: relative; 
		margin-bottom: 12px;
		width:400px;
		.giftIcon{
			position: absolute;
			right: 0;
			top: 0;
			width: 54px;
			height: 57px;
			&.fromFriend{
				background: url('~@/assets/img/ticket/gift.png') top center no-repeat;
				background-size: 100%;
			}				
			&.sendOther{
				background: url('~@/assets/img/ticket/send.png') top center no-repeat;
				background-size: 100%;
			}
			&.showstartSend{
				background: url('~@/assets/img/ticket/showstartsend.png') top center no-repeat;
				background-size: 100%;
			}
		}
		.statusIcon{
			position: absolute;
			right: 10px;
			top: 68px;
			width: 86px;
			height: 86px;
			z-index: 109;
			&.activityCancel{
				background: url('~@/assets/img/ticket/activitycancel.png') top center no-repeat;
				background-size: 100%;
			}				
			&.userCancel{
				background: url('~@/assets/img/ticket/usecancle.png') top center no-repeat;
				background-size: 100%;
			}
			&.end{
				background: url('~@/assets/img/ticket/end.png') top center no-repeat;
				background-size: 100%;
			}
		}
		.top{
			padding:20px;				
			border-radius: 8px;
			background: rgba(255, 255, 255, 0.8);				
			.img{
				float: left;
				width: 56px;
				height: 76px;
				margin-right: 16px;
				border-radius: 4px;					
				img{
					display: block;
					width: 100% ;
					height: 100% ;
					border-radius: 8px;
					vertical-align: middle;
				}
			}
			.rightText{
				
				.name{
					font-size: 14px;
					color: #161616;
					font-weight: bold;
					margin-bottom: 10px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					height: 32px;
					line-height: 16px;
				}
				.address{
					padding-bottom: 8px;
					font-size: 12px;
					color: #999;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.time{
					font-size: 12px;
					color: #999;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		.center{
			border-top:1px dashed #ddd;
			border-bottom: none;				
			position: relative;
			background: rgba(255, 255, 255, 0.8);
			border-radius: 16px 16px 0 0;
			.mid{
				padding:  0 20px; 
				&:last-child{
					.midText{
						border: 0;
					}
				}
			}
			.midText{
				// padding: 40px 50px 30px 40px;
				padding: 10px 0;
				color: #161616;
				font-size: 12px;
				font-weight: bold;
				display: flex;
				align-items: center;
				border-bottom: 1px dashed #ddd;
				span{
					font-weight: bold;
				}
				.wraningIcon{
					margin:0 8px -3px 0;						
					width: 12px;
					height: 12px;	
				}
				.midWenzi{
					display: inline-block;
					padding-top: -10px;
				}
				.rightArrow{
					margin: 0 0 3px 6px;
					border: solid #161616;
					border-width: 0 2px 2px 0;
					display: inline-block;
					padding: 6px;
					transform: rotate(-45deg);
					-webkit-transform: rotate(-45deg);
				}
				
			}
			.midBtn{
				position: absolute;
				right: 40px;
				top: 22px;
				display: inline-block;
				height: 60px;
				line-height: 60px;
				padding:0 40px;
				background: #EB484A;
				border-radius: 30px;
				color: #F8F8F8;
				font-size: 26px;
			}
		}
		.ticketNumView{
			padding: 0 20px;
			background-color: rgba(255, 255, 255, 0.8);
			// border: 1px dashed #ddd;
			border-bottom: none;
			border-top: none;
			> div{
				// height: 90px;
				padding: 20px 0;
				display: flex;
				// align-items: center;
				font-size: 12px;
				font-weight: 600;
				// border-top:1px dashed #ddd;
			}
			text{
				margin-right: 10px;
				flex: 1;
			}
		}
		.midCheckuser{
			padding:0 20px;
			height: 44px;
			line-height: 44px;
			background: linear-gradient(180deg, #262626 0%, #333333 100%);
			font-size: 12px;
			color: #fff;
		}
		.bot{
			padding:17px 20px 20px 20px;						
			border-radius: 0 0 8px 8px;
			background: rgba(255, 255, 255, 0.8) url('~@/assets/img/ticket/graybg.png') center center no-repeat;
			background-size: 100%;
			position: relative;				
			.tkid{
				font-size: 16px;
				color: #fff;
				font-weight: bold;
			}
			.tkStyle{
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding-top: 12px;
				> view{
					display: flex;
					align-items: center;
				}
				.tkName{
					image{
						margin:0 8px 0 0;
						width: 12px;
						height: 12px;
					}
					// padding-top: 20px;
					font-size: 12px;
					color: #fff;
				}
				.tkSend{
					image{
						margin:0 4px 0 0;
						width: 12px;
						height: 12px;
					}
					// padding-top: 25px;
					font-size: 12px;						
					color: #161616;
				}
				
			}
			&.red{
				background: rgba(255, 255, 255, 0.8) url('~@/assets/img/ticket/redbg.png') center center no-repeat;
				background-size: 100%;
			}
			&.normal{
				background: rgba(255, 255, 255, 0.8) url('~@/assets/img/ticket/graybg.png') center center no-repeat;
				background-size: 100%;
			}
			&.blackbg{
				background:#333 url('~@/assets/img/ticket/redbg.png') center center no-repeat;
				background-size: 100%;
			}
			
		}
		&.white{
			.top{
				background: #FFF;
				border: 1px solid #fff;					
			}
			.center{					
				background: #FFF;
				border-width: 1px 0 0 0;
				border-style: dashed;
				border-color: #ddd;					
			}
			.bot{
				background-color: #fff;
			}
			.ticketNumView{
				background-color: rgba(255, 255, 255, 1);
			}		
		}
		&.status5{
			.top{
				background: #FFF;
				border: 1px solid #fff;					
			}
			.center{					
				background: #FFF;
				border-width: 1px 0 0 0;
				border-style: dashed;
				border-color: #ddd;					
			}
			.bot{
				background:#333 url('~@/assets/img/ticket/redbg.png') center center no-repeat;
				background-size: 100%;
			}
			.ticketNumView{
				background-color: #fff;
				border: 0;
			}	
		}
		
	}
}
</style>